import Component from './component';
import footer from '../footer';
import 'base_th_css/components/footer.scss';

export default class FooterContentTH extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }

    enable() {
        this.$el.html(this.state.data);
        footer.init();
        $('body').trigger('footer:enabled');
    }
}
